<section
  class="container"
  *ngIf="candidate$ | async as candidate"
>
  <form
    [formGroup]="form"
    [mojoFormConnect]="candidate"
  >
    <div class="row">
      <div class="image-upload">
        <mojo-image-upload
          (uploadedPhoto)="photo = $event"
          uploadText="Upload photo"
          uploadTextSecondLine="(png, jpg or jpeg)"
          [photoId]="candidate.photoId"
        ></mojo-image-upload>
      </div>
      <div class="candidate-form">
        <div class="row">
          <mat-form-field
            class="col-md-6"
            color="accent"
          >
            <mat-label class="required">First name</mat-label>
            <input
              matInput
              required
              placeholder="First name"
              type="text"
              formControlName="firstName"
              id="firstName"
            />
          </mat-form-field>
          <mat-form-field
            class="col-md-6"
            color="accent"
          >
            <mat-label class="required">Last name</mat-label>
            <input
              matInput
              required
              placeholder="Last name"
              type="text"
              formControlName="lastName"
              id="lastName"
            />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field
            class="col-md-12"
            color="accent"
          >
            <mat-label>Current job title</mat-label>
            <input
              matInput
              placeholder="Current job title"
              type="text"
              formControlName="currentJobTitle"
            />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field
            class="col-md-6"
            color="accent"
          >
            <mat-label>Email</mat-label>
            <input
              matInput
              type="email"
              formControlName="mail"
              id="mail"
            />
          </mat-form-field>
          <common-mojo-phone-input
            formControlName="mobile"
            label="Work number"
            data-cy="profile-logged-in-user-mobile-phone"
          >
          </common-mojo-phone-input>
        </div>
        <div class="row">
          <mat-form-field
            class="col-md-12"
            color="accent"
          >
            <mat-label>Street address</mat-label>
            <input
              matInput
              placeholder="Street address"
              type="text"
              formControlName="streetAddress"
              id="streetAddress"
            />
          </mat-form-field>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mojo-location-input
              label="City, state and country"
              [required]="false"
              [form]="form"
              controlName="locationInput"
            >
            </mojo-location-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mojo-social-info
              controlName="socialInfo"
              [socialInfo]="candidate.socialInfo"
            >
            </mojo-social-info>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <button
        type="submit"
        color="primary"
        mat-raised-button
        class="md save-button"
        (click)="submit(candidate.id)"
      >SAVE
      </button>
    </div>
  </form>
</section>
